import { createContext, useContext } from 'react';
// Allow children component to render a block or inline Atlaskit component variant (e.g AKCode or AKCodeBlock)
export var InlineContext = /*#__PURE__*/createContext({
  inline: false
});
export var useInlineContext = function useInlineContext() {
  return useContext(InlineContext);
};